// extracted by mini-css-extract-plugin
export default {"large":"only screen and (min-width: 992px)","oppositeGenderLink":"_22Gp1 _2AZKg _3cgKO","chevron":"_33R2_","link":"_346Zp _1bfQU _2AZKg"};